export default __webpack_public_path__ + "static/media/delivery-truck.bb603c96.svg";